import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";

import TabForCreateInvoice from "./TabForCreateInvoice";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function CreateInvoiceNew() {
  const navigate = useNavigate();

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">
              <ArrowBackIcon
                className="backArrow"
                onClick={() => navigate("/InvoiceListing")}
              />
              Create Invoice
            </h1>
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <TabForCreateInvoice />
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default CreateInvoiceNew;
